/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Route, Routes,
} from 'react-router-dom';

import ManagedListMatchesContainer from "./ManagedListMatchesContainer";

export default class ManagedListMatchesRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/" element={<ManagedListMatchesContainer/>} />
            </Routes>
        );
    }
}
